import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { loadingBarReducer } from 'react-redux-loading-bar';
import { reducer as oidc } from 'redux-oidc';

import cabinet from './cabinet';
import setting from './settings';
import replenishPlan from './replenishPlan';
import replenishRule from './replenishRule';
import products from './products';
import common from './common';
import planogram from './planogram';

export default history =>
  combineReducers({
    router: connectRouter(history),
    loadingBar: loadingBarReducer,
    cabinet,
    setting,
    planogram,
    replenishPlan,
    replenishRule,
    products,
    oidc,
    common,
  });
